export default "__VITE_ASSET__qEl70X4___"